var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormItem',{attrs:{"label":"个人姓名：","prop":"name"}},[_c('Input',{attrs:{"readonly":"","disabled":""},model:{value:(_vm.formInvoice.name),callback:function ($$v) {_vm.$set(_vm.formInvoice, "name", $$v)},expression:"formInvoice.name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }